var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOffers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1224 13.9983C25.1224 15.1339 23.7224 16.0361 23.3957 17.0472C23.0535 18.105 23.6446 19.645 22.9913 20.5317C22.3379 21.4183 20.689 21.3406 19.8024 21.9783C18.9157 22.6161 18.4957 24.2183 17.4379 24.5606C16.4113 24.8872 15.1357 23.8606 14.0002 23.8606C12.8646 23.8606 11.589 24.9028 10.5624 24.5606C9.5046 24.2183 9.06904 22.6161 8.19793 21.9783C7.31126 21.325 5.64682 21.4183 5.00904 20.5317C4.37126 19.645 4.96237 18.105 4.6046 17.0472C4.27793 16.0361 2.87793 15.1339 2.87793 13.9983C2.87793 12.8628 4.27793 11.9606 4.6046 10.9494C4.94682 9.89166 4.35571 8.33611 5.00904 7.465C5.64682 6.56278 7.31126 6.65611 8.19793 6.00277C9.06904 5.365 9.5046 3.76277 10.5624 3.42055C11.589 3.09389 12.8646 4.12055 14.0002 4.12055C15.1357 4.12055 16.4113 3.07833 17.4379 3.42055C18.4957 3.76277 18.9313 5.365 19.8024 6.00277C20.689 6.65611 22.3535 6.56277 22.9913 7.44944C23.629 8.33611 23.0379 9.87611 23.3957 10.9339C23.7224 11.9606 25.1224 12.8628 25.1224 13.9983Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6088 12.0863C11.3133 12.0863 11.8844 11.5152 11.8844 10.8107C11.8844 10.1062 11.3133 9.53516 10.6088 9.53516C9.90434 9.53516 9.33325 10.1062 9.33325 10.8107C9.33325 11.5152 9.90434 12.0863 10.6088 12.0863Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4841 18.7894C18.1885 18.7894 18.7596 18.2183 18.7596 17.5138C18.7596 16.8094 18.1885 16.2383 17.4841 16.2383C16.7796 16.2383 16.2085 16.8094 16.2085 17.5138C16.2085 18.2183 16.7796 18.7894 17.4841 18.7894Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 9.33203L9.33325 18.6654",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.529907c9.svg";
export { ForwardRef as ReactComponent };